




























































import { Component, Vue, Prop } from 'vue-property-decorator';
import SidebarItem from './SidebarItem.vue';
import { FileSystemItem } from '../../services/FileSystem.service';

@Component({
  components: {
    SidebarItem,
  },
})
export default class Sidebar extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  readonly filesAndFolders!: FileSystemItem[];

  @Prop({
    type: String,
    required: false,
    default: undefined,
  })
  readonly selectedPath!: string;

  @Prop({
    type: String,
    required: false,
    default: undefined,
  })
  readonly pathBeingEdited!: string;

  @Prop({
    type: Array,
    required: true,
  })
  readonly collapsedPaths!: string[];

  pathSelected(path: string) {
    this.$emit('pathSelected', path);
  }

  pathEditing(path: string) {
    this.$emit('pathEditing', path);
  }

  pathRenamed(...args) {
    this.$emit('pathRenamed', ...args);
  }

  pathDeleted(path: string) {
    this.$emit('pathDeleted', path);
  }

  folderToggled(path: string) {
    this.$emit('folderToggled', path);
  }

  newFolderClicked() {
    this.$emit('newFolder');
  }

  newFileClicked() {
    this.$emit('newFile');
  }
}
